import { cssRule } from 'typestyle'
cssRule('.psfollowText', {
  fontSize: '14px',
  color: '#666666',
  textAlign: 'center',
  lineHeight: '14px',
  paddingTop: '30px',
  paddingBottom: '16px'
})
cssRule('.psfollowLight', {
  color: '#ff5a31'
})
// cssRule('.lightLink', {
//   color: '#ff5a31'
// });
// cssRule('.lightLink:active', {
//   color: '#e4431b'
// });
cssRule('.normalColor', {
  color: '#666666'
})
cssRule('.psfollowActivity', {
  width: '100%'
})
cssRule('.psFollowLike', {
  padding: '0 15px'
})
cssRule('.psLikeTitle', {
  fontSize: '18px',
  color: '#333333',
  letterSpacing: 0,
  lineHeight: '25px',
  paddingTop: '20px'
})
cssRule('.psLikeContent', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  width: '100%'
})
cssRule('.psLikeItem', {
  background: '#ffffff',
  marginBottom: '25px'
  // maxWidth: '213.7px',
  // position: 'relative',
  // width: '44.53vw'
})
// cssRule('.psLikeItem::before', {
//   border: '1px solid #e1e1e1',
//   borderRadius: '8px',
//   boxSizing: 'border-box',
//   content: '""',
//   height: '200%',
//   position: 'absolute',
//   transform: 'scale(0.5, 0.5)',
//   transformOrigin: '0 0',
//   width: '200%'
// })
cssRule('.psLikeCover', {
  width: '100%',
  borderRadius: '4px 4px 0 0',
  display: 'block'
})
cssRule('.psLikeHead', {
  position: 'relative',
  height: '22.93333vw',
  maxHeight: '120px',
  overflow: 'hidden'
})
cssRule('.psLikeHeadMask', {
  background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6))',
  display: 'flex',
  height: '50px',
  position: 'absolute',
  width: '100%',
  bottom: 0,
  color: '#fff',
  alignItems: 'flex-end',
  paddingLeft: '10px',
  paddingBottom: '5px'
})
cssRule('.psLikeFtIcon', {
  width: '12px',
  display: 'inline-block',
  marginRight: '5px',
  verticalAlign: 'middle'
})
cssRule('.psLikeFtText', {
  verticalAlign: 'middle',
  marginRight: '15px'
})
cssRule('.psLikeName', {
  color: '#333333',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  marginBottom: '7px',
  padding: '7px 10px',
  height: '59px'
})
cssRule('.RecommendItem', {
    textDecoration: 'none'
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeRecommendModule/HomeRecommendModule.style.ts